import mixpanel from "mixpanel-browser";

// Initialize Mixpanel
mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN || "YOUR_TOKEN", {
  debug: false,
  track_pageview: false,
  persistence: "localStorage",
});

// Create a wrapper for type-safety and convenience
const analytics = {
  track: (event: string, properties?: Record<string, unknown>) => {
    mixpanel.track(event, properties);
  },
  identify: (userId: string) => {
    mixpanel.identify(userId);
  },
  reset: () => {
    mixpanel.reset();
  },
  people: {
    set: (properties: Record<string, unknown>) => {
      mixpanel.people.set(properties);
    },
  },
};

export default analytics;
